import { H1, H2, H3, H4 } from '@/components/atoms';
import { ReactElement, ReactNode } from 'react';

interface IProps {
  children: ReactNode;
  level: number;
  color?: string;
}

const Heading = (props: IProps) => {
  const { level, children, color = 'gray-600' } = props;
  const header: { [index: number]: ReactElement } = {
    '1': <H1 color={color}>{children}</H1>,
    '2': <H2 color={color}>{children}</H2>,
    '3': <H3 color={color}>{children}</H3>,
    '4': <H4 color={color}>{children}</H4>,
  };
  return header[level];
};

export default Heading;
